import swatchGroupStyles from '@salesforce/retail-react-app/app/theme/components/project/swatch-group'
import {remCalc} from '../../_utils'

export default {
    ...swatchGroupStyles,
    baseStyle: {
        ...swatchGroupStyles.baseStyle(),
        swatchLabel: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            marginBottom: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        swatchLabelText: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        swatchLabelValue: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        swatchesWrapper: {
            overflowX: 'auto',
            whiteSpace: {base: 'nowrap', lg: 'wrap'},
            flexWrap: {base: 'nowrap', lg: 'wrap'},
            gap: {base: 'xxsmall.base', sm: 'xxsmall.sm', md: 'xsmall.md', lg: 'xsmall.lg'},
            padding: remCalc(2),
        },
        colorBox: {
            width: '100%',
            height: '100%',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'background.base.default',
            borderRadius: 'full',
        },
        checkmarkIcon: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
            height: ['medium-1.base', 'medium-1.sm', 'medium-1.md', 'medium-1.lg'],
            aspectRatio: '1 / 1',
            backgroundColor: 'transparent',
            borderRadius: 'full',
            boxShadow: 'var(--chakra-shadows-neutral-sm, 0 1px 3px rgba(0, 0, 0, 0.25))',
            color: 'background.base.default',
        },
        checkmarkGlyph: {
            width: remCalc(12),
            height: remCalc(12),
            color: 'background.base.default',
        },
        priceSection: {
            marginTop: remCalc(8),
            fontSize: remCalc(12),
            textAlign: 'center',
        },
        priceValue: {
            fontWeight: 'bold',
        },
    },
    variants: {
        ...swatchGroupStyles.variants,
        image: ({size}: {size: string}) => ({
            swatch: {
                border: 'none',
                height: size === 'small' ? remCalc(58) : remCalc(80),
                width: size === 'small' ? remCalc(48) : remCalc(80),
                marginRight: remCalc(8),
                marginBottom: remCalc(8),
            },
            swatchButton: {
                border: 'none',
            },
        }),
        circle: ({hexColor, selected}: {hexColor?: string; selected?: boolean}) => ({
            swatch: {
                height: {
                    base: remCalc(40),
                    sm: remCalc(40),
                    md: remCalc(48),
                    lg: remCalc(48),
                    xl: remCalc(48),
                },
                width: {
                    base: remCalc(24),
                    sm: remCalc(24),
                    md: remCalc(32),
                    lg: remCalc(32),
                    xl: remCalc(32),
                },
                minWidth: {
                    base: remCalc(24),
                    sm: remCalc(24),
                    md: remCalc(32),
                    lg: remCalc(32),
                    xl: remCalc(32),
                },
                cursor: 'pointer',
                p: 0,
                border: 'small',
                borderStyle: 'solid',
                borderColor: hexColor ? 'transparent' : 'border.light',
                borderRadius: 'full',
                position: 'relative',
                ...(selected && {
                    borderRadius: 'full',
                    boxShadow:
                        '0 0 0 1px var(--background-base-default, #EFEDEA) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 2px var(--border-neutral-focus, #6C7BA8)',
                }),
            },
            swatchButton: {
                minWidth: 'auto',
                marginRight: 0,
                height: '100%',
                width: '100%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                cursor: 'pointer',
                _notDisabled: {
                    cursor: 'pointer',
                },
                _hover: {
                    opacity: 0.8,
                },
                _focus: {
                    outline: 'none',
                },
            },
        }),
        square: ({
            hexColor,
            selected,
            size,
        }: {
            hexColor?: string
            selected?: boolean
            size?: string
        }) => ({
            swatch: {
                position: 'relative',
                width:
                    size === 'compare'
                        ? {
                              base: remCalc(16),
                              sm: remCalc(16),
                              md: remCalc(24),
                              lg: remCalc(24),
                              xl: remCalc(24),
                          }
                        : {
                              base: remCalc(24),
                              sm: remCalc(24),
                              md: remCalc(32),
                              lg: remCalc(32),
                              xl: remCalc(32),
                          },
                height:
                    size === 'compare'
                        ? {
                              base: remCalc(24),
                              sm: remCalc(24),
                              md: remCalc(36),
                              lg: remCalc(36),
                              xl: remCalc(36),
                          }
                        : {
                              base: remCalc(40),
                              sm: remCalc(40),
                              md: remCalc(48),
                              lg: remCalc(48),
                              xl: remCalc(48),
                          },
                minWidth:
                    size === 'compare'
                        ? {
                              base: remCalc(16),
                              sm: remCalc(16),
                              md: remCalc(24),
                              lg: remCalc(24),
                              xl: remCalc(24),
                          }
                        : {
                              base: remCalc(24),
                              sm: remCalc(24),
                              md: remCalc(32),
                              lg: remCalc(32),
                              xl: remCalc(32),
                          },
                backgroundImage: 'none',
                cursor: 'pointer',
                p: 0,
                ...(selected && {
                    borderRadius: 'var(--full, 999px)',
                    background: 'var(--background-base-default, #EFEDEA)',
                    boxShadow:
                        size === 'compare'
                            ? '0 0 0 1px var(--chakra-colors-background-base-default) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 2px var(--chakra-shadows-accent-lg)'
                            : '0 0 0 1px var(--background-base-default, #EFEDEA) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 2px var(--border-neutral-focus, #6C7BA8)',
                }),
            },
            swatchButton: {
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: hexColor ? hexColor : 'transparent',
                borderColor: hexColor ? 'border.default' : undefined,
                border: hexColor ? '1px solid' : undefined,
                cursor: 'pointer',
                _notDisabled: {
                    cursor: 'pointer',
                },
                _hover: {
                    opacity: 0.8,
                },
            },
        }),
    },
    parts: [
        'swatch',
        'swatchButton',
        'swatchLabelText',
        'swatchLabelValue',
        'colorBox',
        'checkmarkIcon',
        'checkmarkGlyph',
        'priceSection',
        'priceValue',
    ],
}
